import React, { useState, useContext, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FuncionesContext from "../context/FuncionesContext";
import axios from "axios";

import PropTypes from "prop-types";

import useMediaQuery from "@mui/material/useMediaQuery";
import ListSubheader from "@mui/material/ListSubheader";

import { useTheme } from "@mui/material/styles";
import { VariableSizeList } from "react-window";
import Typography from "@mui/material/Typography";

import { farmageo_api } from "../../../config";

import { useRefDataStore } from "../../..";

import Label from "../ABM/componentes/inputs/LabelF";

const LISTBOX_PADDING = 8; // px

function renderRow(props) {
  const { data, index, style } = props;
  const dataSet = data[index];
  const inlineStyle = {
    ...style,
    top: style.top + LISTBOX_PADDING,
    fontSize: "0.80rem",
  };

  if (dataSet.hasOwnProperty("group")) {
    return (
      <ListSubheader key={dataSet.key} component="div" style={inlineStyle}>
        {dataSet.group}
      </ListSubheader>
    );
  }

  return (
    <Typography component="li" {...dataSet[0]} noWrap style={inlineStyle}>
      {dataSet[1]}
    </Typography>
  );
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...other } = props;
  const itemData = [];
  children.forEach((item) => {
    itemData.push(item);
    itemData.push(...(item.children || []));
  });

  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"), {
    noSsr: true,
  });

  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child) => {
    if (child.hasOwnProperty("group")) {
      return 48;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

ListboxComponent.propTypes = {
  children: PropTypes.node,
};

export default function Virtualize(props) {
  const {
    cab,
    data,
    context,
    campokey,
    id_elemento,
    valor,
    updateid,
    modoAlta,
    error,
    setError: setErrorABM,
    setOpcionSeleccionada,
  } = props;
  const { superSubmit } = useContext(FuncionesContext);

  const [value, setValue] = useState("");
  const [inputValue, setInputValue] = useState("");

  const [v, setStore] = useRefDataStore((s) => s[data._key + campokey]);
  const [update_id] = useRefDataStore(
    (s) => s[data._key + cab.update_id_alias]
  );

  const [opciones, setOpciones] = useState([]);
  const [fetchTimeout, setFetchTimeout] = useState();
  const [updateId, setUpdateId] = useState(update_id ?? updateid);
  const [loading, setLoading] = useState(false);

  const { id_a } = cab;

  const handleCancelar = () => {};

  function setError(error) {
    if (cab.tipo.id === 10) {
      setErrorABM((e) => {
        return { ...e, [id_a]: false };
      });
    }
  }

  const handleChangeValue = async (newValue) => {
    setError(false);
    const valor = newValue.value; //newValue { value, label }

    // En ABM conserva la respuesta completa para que otros componentes puedan
    // consultar sus datos complementarios desde valorFormulario.<id_a>_op.
    if (setOpcionSeleccionada) {
      setOpcionSeleccionada(newValue);
    }

    if (cab.tipo.id === 10) {
      const { setValor } = props;
      setValor(newValue.value);
      setValue(newValue.label);
      setStore({ [data._key + campokey]: valor });
      setStore({ [data._key + campokey + "_label"]: newValue.label });
      return;
    }

    superSubmit({ valor, id_a, update_id: updateId, handleCancelar, cab, data })
      .then((result) => {
        setStore({ [data._key + campokey]: valor });
        setStore({ [data._key + campokey + "_label"]: newValue.label });
        if (!updateId) {
          setStore({
            [data._key + cab.update_id_alias]: result.data.registro.id,
          });
          setUpdateId(result.data.registro.id);
        }
        setUpdateId(result.data.registro.id);
        setValue(newValue.label); // esto deberia ser newValue.id pero funciona asi
        // setInputValue(newValue.label);
      })
      .catch((err) => {
        console.log("Cancelado ", err);
      });
  };

  const onInputChange = async (event, newInputValue) => {
    clearTimeout(fetchTimeout); // Utiliza el identificador del temporizador
    setError(false);
    const minValuelength = cab.autocompletar_minimo ?? 4;
    const minValueReached = newInputValue.length > minValuelength;
    if (minValueReached) {
      const newTimeout = setTimeout(() => {
        setLoading(true);
        axios
          .post(farmageo_api + "/autocompletar/opciones/" + cab.id_a, {
            value: newInputValue,
          })
          .then((res) => {
            setLoading(false);
            setOpciones(() =>
              res.data.sort((a, b) =>
                a.label.toUpperCase().localeCompare(b.label.toUpperCase())
              )
            );
          });
      }, 800);
      setFetchTimeout(newTimeout);
    }
    setInputValue(newInputValue);
  };

  useEffect(() => {
    if (v) {
      setLoading(true);
      setError(false);
      axios
        .post(farmageo_api + "/autocompletar/opciones/" + cab.id_a, {
          value: v,
        })
        .then((res) => {
          setLoading(false);
          setOpciones(() => res.data);
          setValue(res.data[0].label);
          if (setOpcionSeleccionada) {
            setOpcionSeleccionada(res.data[0]);
          }
          //setea informacion para recuperarla como dataView
          setStore({ [data._key + campokey + "_label"]: res.data[0].label });
        });
    }
  }, [cab.id_a, setOpcionSeleccionada, v]);

  useEffect(() => {
    if (cab.tipo.id === 10 && !modoAlta && valor) {
      setLoading(true);
      setError(false);
      axios
        .post(farmageo_api + "/autocompletar/opciones/" + cab.id_a, {
          value: valor,
        })
        .then((res) => {
          setLoading(false);
          setOpciones(() => res.data);
          setValue(res.data[0].label);
          if (setOpcionSeleccionada) {
            setOpcionSeleccionada(res.data[0]);
          }
          //setea informacion para recuperarla como dataView
          setStore({ [data._key + campokey + "_label"]: res.data[0].label });
        });
    }
  }, [
    cab.id_a,
    cab.tipo.id,
    campokey,
    data._key,
    modoAlta,
    setOpcionSeleccionada,
    setStore,
    valor,
  ]);

  return (
    <>
      <div>
        {cab.nombre ? (
          <Label
            label={cab.nombre}
            opcionales_null={cab.opcionales_null}
            permite_null={cab.permite_null}
          />
        ) : (
          <></>
        )}
      </div>
      <Autocomplete
        value={value}
        id={id_elemento}
        sx={{ width: "100%" }}
        disableListWrap
        disableClearable
        size="small"
        openText="Abrir"
        closeText="Cerrar"
        noOptionsText="No se encontraron resultados"
        className={` ${data[cab.id_a + "_className"] ?? cab.className}`}
        filterOptions={(x) => x}
        ListboxComponent={ListboxComponent}
        options={opciones}
        groupBy={(option) => {
          return option.label[0].toUpperCase();
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={cab.placeholder}
            style={{ border: error[id_a] ? "1px solid red" : "unset" }}
            className={` _autoComplete ${loading ? "loader" : ""}`}
          />
        )}
        renderOption={(props, option) => [props, option.label]}
        // TODO: Post React 18 update - validate this conversion, look like a hidden bug
        renderGroup={(params) => params}
        onChange={(event, newValue) => handleChangeValue(newValue)}
        inputValue={inputValue}
        onInputChange={onInputChange}
        getOptionLabel={(option) => {
          return option.label ?? option;
        }}
      />
    </>
  );
}
